import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import '../CSS/DesktopNav.css'


const NavTablet = () => {

    // eslint-disable-next-line
    const [visibleMenu, setVisibleMenu] = useState(false);
    const [showCross, setShowCross] = useState(false);
    const [addNavClass,setAddNavClass] = useState('');

    const [HomeID, setHomeID] = useState();
    const [CuID, setCunId] = useState();
    const [TestID, setTestID] = useState();
    const [AppoinID, setAppoinID] = useState();
    const [profileId, setProfID] = useState();
    const [BookID, setBookId] = useState();

    const handleCrossClick = () => {
        setVisibleMenu(false);
        setShowCross(false);
        setAddNavClass(false);
    }
      const handleMenuClick = () => {
        setVisibleMenu(true);
        setShowCross(true);
        setAddNavClass(true);
    }   

    return (
        <div className={addNavClass ? "increaseNavWidth" : "showMenuDesk"}>
           <ul>
                <li id='menuIconTablet'>
                    { !showCross ? (
                    <i className="fas fa-bars" id='menuIconTablet'  onClick={(e) => handleMenuClick() }></i>
                    ) : (
                        <i className="fas fa-times-circle" onClick={(e) => handleCrossClick()}></i>
                    ) 
                }    
                </li>

                <li onClick={(e) => handleCrossClick()}  id={HomeID ? 'activeHomeId' : ''} >
                    <Link to='/' onClick={(e) => setHomeID(true)}>
                        <i className="fas fa-home"></i>
                        <p className={addNavClass ? "showOptions" : "navTabOptions"}>Home</p>
                    </Link>
                </li>
                <li onClick={(e) => handleCrossClick()}  id={CuID ? 'activeHomeId' : ''}>
                    <Link to='/Counsellors_page' onClick={(e) => setCunId(true)}>
                    <i className="fas fa-user"></i>
                    <p className={addNavClass ? "showOptions" : "navTabOptions"} >Counsellors</p>
                    </Link>
                </li>
                <li onClick={(e) => handleCrossClick()} id={TestID ? 'activeHomeId' : ''}>
                    <Link to='/typeofTest' onClick={(e) => setTestID(true)}>
                    <i className = "fas fa-stethoscope"></i>
                    <p className={addNavClass ? "showOptions" : "navTabOptions"} >Self Test</p>
                    </Link>
                </li>
                <li onClick={(e) => handleCrossClick()} id={AppoinID ? 'activeHomeId' : ''}>
                    <Link to='/AppointmentPage' onClick={(e) => setAppoinID(true)}>
                    <i className="fas fa-clock"></i>
                    <p className={addNavClass ? "showOptions" : "navTabOptions" } >Appointment</p>
                    </Link>
                </li>
                <li onClick={(e) => handleCrossClick()} id={profileId ? 'activeHomeId' : ''}>
                    <Link to='/Profile_Page' onClick={(e) => setProfID(true)}>
                    <i className="fas fa-address-card"></i>
                    <p className={addNavClass ? "showOptions" : "navTabOptions"} >Profile</p>
                    </Link>
                </li>
                <li onClick={(e) => handleCrossClick()} id={BookID ? 'activeHomeId' : ''}>
                    <Link onClick={(e) => setBookId(true)} to='/Booking_Page' >
                    <i className="fas fa-calendar-alt" ></i>
                    <p className={addNavClass ? "showOptions" : "navTabOptions"}>Booking</p>
                    </Link>
                </li>  
                 
            </ul> 
        </div>
    )
}

export default NavTablet
